/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { fractionDependencies } from './dependenciesFraction.generated.js';
import { identityDependencies } from './dependenciesIdentity.generated.js';
import { invDependencies } from './dependenciesInv.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { numberDependencies } from './dependenciesNumber.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createPow } from '../../factoriesAny.js';
export var powDependencies = {
  ComplexDependencies,
  fractionDependencies,
  identityDependencies,
  invDependencies,
  matrixDependencies,
  multiplyDependencies,
  numberDependencies,
  typedDependencies,
  createPow
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesPow.generated.js
// module id = 117
// module chunks = 2